import { Component, Input } from '@angular/core';

@Component({
    selector: 'cp-filtered-items',
    templateUrl: './filtered-items.component.html',
    styleUrls: ['./filtered-items.component.scss'],
    standalone: false
})
export class FilteredItemsComponent {

    @Input() data = [];
    @Input() inclusivity?: boolean = true;
    @Input() title: string = '';
    @Input() trimLength?: number = 5;
    @Input() dark?: boolean = false;
    @Input() fillmode?: string = 'solid';

}
